module.exports = {"name":"Org","component":"Org","clauses":{"avg":{"en":"Averages","jp":"現在の平均"},"days":{"en":"Days Remaining","jp":"残日数"},"day":{"en":"Day Remaining","jp":"残り日"},"add":{"en":"Add Building","jp":"ビルディングの追加"},"floors":{"en":"Floors","jp":"階"},"floor":{"en":"Floor","jp":"階"},"rooms":{"en":"Rooms","jp":"部屋"},"room":{"en":"Room","jp":"部屋"},"learning":{"en":"Learning...","jp":"学んで"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates/OrgTemplate.json
// module id = 65
// module chunks = 1